import { DashboardModuleListItem, Image } from '@domain-group/suit-theme'

import useImage from '@hooks/useImage'

import { confirmDelete } from '@functions/entity'

import { ImageModel } from '@models/types'

interface ImageListItemProps {
  image: ImageModel,
}

const ImageListItem = (props: ImageListItemProps) => {
  const { image } = props

  const imagePayload = useImage(image)
  const {
    callbacks: { createOrEditImage, deleteImage: deleteFn },
    image: {
      file_file_name, square_url, size,
    },
  } = imagePayload

  const { original: { height, width } } = size

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      entityName: 'Image',
    },
  }

  return (
    <DashboardModuleListItem
      boxProps={{ paddingX: 0 }}
      imageComponent={(
        <Image
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          url={square_url}
        />
        )}
      isSidebar
      secondaryText={`${width} x ${height} px`}
      title={file_file_name}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditImage()}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default ImageListItem
